// This factory also runs inside the editor iframe. Keep it self-contained.
export function createEditorViewport(scroller) {
    let target = null;
    let cleanups = [];
    function cancel() {
        target = null;
        cleanups.forEach(cleanup => cleanup());
        cleanups = [];
    }
    function restore() {
        if (!target) return;
        scroller.scrollTop = target.top;
        scroller.scrollLeft = target.left;
    }
    // A delayed image load must not undo a student's next deliberate scroll.
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => scroller.ownerDocument.addEventListener(type, cancel, { capture: true, passive: true }));
    return {
        update(render) {
            const position = target || { top: scroller.scrollTop, left: scroller.scrollLeft };
            cancel();
            target = position;
            render();
            restore();
            let pending = 0;
            scroller.querySelectorAll('img').forEach(image => {
                if (image.complete) return;
                pending++;
                const loaded = () => { restore(); if (--pending === 0) cancel(); };
                image.addEventListener('load', loaded, { once: true });
                image.addEventListener('error', loaded, { once: true });
                cleanups.push(() => { image.removeEventListener('load', loaded); image.removeEventListener('error', loaded); });
            });
            if (!pending) cancel();
        },
        cancel
    };
}
